// extracted by mini-css-extract-plugin
export default {"formLayout":"HairToneForm-module-formLayout-K_yX3"};